<template>
  <div class="wheel-container">
    <!-- Filtering Section as a Header (Single Line) -->
    <div class="filter-section">
      <b-row class="filter-row">
        <b-col lg="3">
          <label class="some-label" for="select-building">{{ translate('selectDrawFor') }}</label>
          <b-form-select id="draw-type" v-model="drawType" @change="resetEkubType">
            <option v-for="option in drawOptions" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </b-form-select>
        </b-col>
        <b-col lg="3" v-if="drawType === 'Individual'">
          <label class="some-label" for="select-status">{{ translate('association') }}</label>
          <b-form-select v-model="ekubType" id="ekub-type">
            <option v-for="option in ekubOptions" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </b-form-select>
        </b-col>
        <b-col lg="3" v-if="drawType === 'Group'">
          <label class="some-label" for="select-status">{{ translate('numberOfEkub') }}</label>
          <input v-model.number="numberOfEkub" id="number-of-ekub" type="number" placeholder="Enter number of Ekub" min="1">
        </b-col>
        <b-col lg="1" class="mt-1">
          <b-button class="btn-secondary" id="datepicker-btn" @click="filterDrawingUsingEkubTypeId" :disabled="isFindButtonDisabled">{{ translate('find') }}</b-button>
        </b-col>
      </b-row>
    </div>
    <div class="wheel-section">
        <canvas ref="wheelCanvas" class="wheel-canvas" width="500" height="500"></canvas>
        <!-- Spin Button -->
        <button v-if="items.length > 0" @click="spinWheel" :disabled="spinning" class="spin-button">
          SPIN
        </button>
      </div>
    <!-- Winner Overlay -->
    <div class="winner-overlay" v-if="showWinnerOverlay">
      <div class="winner-message">
        <h2>Congratulations!</h2>
        <p>{{ winnerMessage }}</p> <!-- Display the API response message -->
        <button @click="closeWinnerOverlay" class="close">Close</button>
      </div>
    </div>
    <!-- No Data Message -->
    <div v-if="!items.length && !spinning" class="no-data-message">
      <p>No data to spin. Please add items to the wheel.</p>
    </div>
  </div>
</template>
<script>
import axios from 'axios'; // Assuming you're using axios
import { setLanguage, translate } from 'src/i18n.js';

export default {
  name: 'WheelOfNames',
  data() {
    return {
      items: [], // Start with an empty array for items
      userInput: '',
      angle: 0,
      spinning: false,
      selectedItem: null,
      showWinnerOverlay: false,
      winnerMessage: '', // To hold the winner's message from the API
      spinSound: new Audio(require('@/assets/sound/drawingSound-[AudioTrimmer.com].mp3')),
      winnerSound: new Audio(require('@/assets/sound/winningSound.mp3')),
      // Filtering state
      drawType: '', // Default value for draw type
      ekubType: null, // Default Ekub type
      numberOfEkub: 1, // Default number of Ekub for Group
      drawOptions: [
        { value: 'Individual', label: 'Individual' },
        { value: 'Group', label: 'Assocation' }
      ],
      ekubOptions: [],
    };
  },
  computed: {
    isFindButtonDisabled() {
    // Ensure that the button is only enabled if all required filters are set
    if (this.drawType === 'Individual') {
      return !this.ekubType;  // Button disabled if no Ekub Type selected
    } else if (this.drawType === 'Group') {
      return this.numberOfEkub <= 0;  // Button disabled if number of Ekub is not valid
    }
    return true; // Button disabled by default if no draw type is selected
  },
  },
  methods: {
    translate,
    changeLanguage(lang) {
      setLanguage(lang);
      this.$forceUpdate();
    },
    // Fetch Ekub Types by user ID and update the ekubOptions array
    getEkubType() {
      this.$store.dispatch('getEkubsByOwnerID', { userId: sessionStorage.getItem("ID") })
        .then(response => {
          this.ekubOptions = response.data.map((value) => ({
            value: value.id,
            label: value.ekubName
          }));
        })
        .catch(error => {
          this.$notify({
            // message: error.response.data,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            title: error.data,
            text: error.response.data,
            type: 'danger'
          });
        });
    },
    // This is the function that handles the "Find" button click
    filterDrawingUsingEkubTypeId() {
  // Start by clearing the items array to avoid displaying old data
  this.items = [];

  // Handle "Individual" case
  if (this.drawType === 'Individual' && this.ekubType) {
    const requestBody = {
      ekubTypeId: this.ekubType,
      userId: sessionStorage.getItem("ID"),
    };

    this.$store.dispatch('filterDrawingUsingEkubTypeId', requestBody)
      .then(response => {
        if (response.data && response.data.length > 0) {
          this.items = response.data.map(entry => entry.fullName);
          this.drawWheel();  // Draw the wheel with the new data
        } else {
          this.$notify({
            title: 'No Data Found',
            text: 'No members found for the selected Ekub Type.',
            type: 'info',
          });
        }
      })
      .catch(error => {
        this.$notify({
          // message: error.response.data,
          horizontalAlign: 'center',
          verticalAlign: 'top',
          title: error.data,
          text: error.response ? error.response.data : 'An unexpected error occurred.',
          type: 'danger',
        });
        console.log(response.data);
      });
  }
  // Handle "Group" case
  else if (this.drawType === 'Group' && this.numberOfEkub > 0) {
    const requestBody = {
      numberOfEkub: this.numberOfEkub,
      userId: sessionStorage.getItem("ID"),
    };

    this.$store.dispatch('filterDrawingUsingForGroup', requestBody)
      .then(response => {
        if (response.data && response.data.length > 0) {
          this.items = response.data.map(entry => entry.ekubTypeName);
          this.drawWheel();  // Draw the wheel with the new data
        } else {
          this.$notify({
            title: 'No Data Found',
            text: 'No group data found for the selected number of Ekub.',
            type: 'info',
          });
        }
      })
      .catch(error => {
        this.$notify({
          // message: error.response.data,
          horizontalAlign: 'center',
          verticalAlign: 'top',
          title: error.data,
          text: error.response ? error.response.data : 'An unexpected error occurred.',
          type: 'error',
        });
      });
  } else {
    this.$notify({
      title: 'Invalid Filter',
      text: 'Please select a valid filter option.',
      type: 'danger',
    });
  }
},
    // Method to reset Ekub type when the user switches draw type
    resetEkubType() {
      if (this.drawType !== 'Individual') {
        this.ekubType = null;
      } else {
        this.getEkubType();
      }
    },
    // Draw the wheel based on the items
    drawWheel() {
      const canvas = this.$refs.wheelCanvas;
      const ctx = canvas.getContext('2d');
      const radius = canvas.width / 2;
      const numItems = this.items.length;
      const anglePerItem = (2 * Math.PI) / numItems;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (numItems === 0) {
        // Draw a full green circle if there are no items
        ctx.fillStyle = '#28a745'; // Green
        ctx.beginPath();
        ctx.arc(radius, radius, radius, 0, 2 * Math.PI);
        ctx.fill();
        return;
      }

      // Colors for the wheel segments
      const colors = ['#ff0000', '#00cc00', '#0066ff', '#ffcc00', '#ff6600', '#0099cc'];
      // Draw the wheel sections
      for (let i = 0; i < numItems; i++) {
        const startAngle = i * anglePerItem;
        const endAngle = startAngle + anglePerItem;
        ctx.fillStyle = colors[i % colors.length]; // Cycle through colors
        ctx.beginPath();
        ctx.moveTo(radius, radius);
        ctx.arc(radius, radius, radius, startAngle, endAngle);
        ctx.closePath();
        ctx.fill();
        // Draw the item labels
        ctx.fillStyle = 'white';
        ctx.font = '18px Arial';
        const label = this.items[i];
        const labelWidth = ctx.measureText(label).width;
        const labelHeight = 18;
        const labelX = radius + Math.cos(startAngle + anglePerItem / 2) * (radius - 40) - labelWidth / 2;
        const labelY = radius + Math.sin(startAngle + anglePerItem / 2) * (radius - 40) + labelHeight / 2;
        ctx.fillText(label, labelX, labelY);
      }
    },
    // Spin the wheel when the SPIN button is clicked
    spinWheel() {
      if (this.spinning) return;

      // Ensure we have selected items to spin
      if (!this.items.length) {
        alert("There are no items to spin. Please add items to the wheel.");
        return;
      }
      this.spinning = true;
      const randomSpinAngle = Math.random() * 5000 + 5000; // Random spin angle between 5000 and 10000 degrees
      const canvas = this.$refs.wheelCanvas;
      canvas.style.transition = 'transform 5s ease-out';
      canvas.style.transform = `rotate(${this.angle + randomSpinAngle}deg)`; // Spin by the random angle
      this.spinSound.play(); // Play the spin sound effect

      // Calculate the winner based on the final angle
      const finalAngle = (this.angle + randomSpinAngle) % 360;
      const sectionAngle = 360 / this.items.length;
      const selectedIndex = Math.floor((finalAngle + sectionAngle / 2) / sectionAngle) % this.items.length;

      const selectedItem = this.items[selectedIndex];
      const ekubJoinerId = this.getEkubJoinerId(selectedItem);

      // Call the winner API after spin
      setTimeout(() => {
        this.callWinnerAPI(selectedItem, ekubJoinerId);
      }, 5000); // Wait for spin to finish

      this.angle += randomSpinAngle;
    },
    getEkubJoinerId(selectedItem) {
      return this.items.indexOf(selectedItem);
    },
    callWinnerAPI(selectedItem, ekubJoinerId) {
      const requestBody = {
        userId: sessionStorage.getItem("ID"),
        registeredBy: parseInt(sessionStorage.getItem("userID")),
        ekubTypeId: this.ekubType, // Ekub Type ID
        ekubJoinerId: ekubJoinerId, // Selected Ekub Joiner ID
      };
      this.$store.dispatch('callForWinningForIndividual', requestBody)
      .then(response => {
        if (response.data && response.data.length > 0) {
          this.winnerMessage = response.data.message || `The Winner: ${selectedItem}`;
          this.showWinnerOverlay = true; // Show the winner overlay
          this.winnerSound.play(); // Play winner sound
        } else {
          this.$notify({
            title: 'No Data Found',
            text: 'No members found for the selected Ekub Type.',
            type: 'info',
          });
        }
      })
      .catch(error => {
        this.$notify({
          // message: error.response.data,
          horizontalAlign: 'center',
          verticalAlign: 'top',
          title: error.data,
          text: error.response ? error.response.data : 'An unexpected error occurred.',
          type: 'danger',
        });
      });
    },
  closeWinnerOverlay() {
  this.showWinnerOverlay = false;
  this.resetModule();
  window.location.reload();  // This will reload the page
},
resetModule() {
  this.drawType = '';       // Clear draw type
  this.ekubType = null;     // Clear Ekub type selection
  this.numberOfEkub = 1;    // Default number of Ekub for Group
  this.items = [];          // Clear filtered items
  this.angle = 0;           // Reset wheel angle
  this.spinning = false;    // Reset spinning flag
  this.selectedItem = null; // Clear selected item
  this.showWinnerOverlay = false;  // Hide winner overlay
},
  },
  mounted() {
    this.getEkubType();
  },
};
</script>
<style scoped>
.wheel-container {
  text-align: left;
  margin-left: 0.5%;
}
.wheel-canvas {
  margin-top: 10px;
}
.wheel-section {
  position: relative;
  width: 500px;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.spin-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  font-size: 18px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s;
}

.winner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center; /* Centers the winner-message horizontally */
  align-items: center; /* Centers the winner-message vertically */
  background-color: rgba(0, 0, 0, 0.5); /* Optional: overlay effect */
}

.winner-message {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  text-align: center;
  max-width: 500px;
  width: 100%;
  display: flex;
  flex-direction: column; /* Stack elements vertically */
  justify-content: space-between; /* Pushes content to top and button to bottom */
  height: 250px; /* You can adjust the height as needed */
}

.close {
  background-color: rgb(37, 91, 48);
  color: rgba(240, 206, 13, 0.937);
  text-align: center;
  padding: 10px 20px;
  border: 2px solid rgb(37, 91, 48);
  border-radius: 8px;
  cursor: pointer;
  margin-top: auto; /* Push the button to the bottom */
}

.no-data-message {
  text-align: center;
  color: red;
  margin-top: 20px;
  font-size: 18px;
}

.some-label {
}
</style>
